export default __webpack_public_path__ + "static/media/snowman_gif.6e0b319d.gif";